import { Component, OnChanges, Input, ChangeDetectorRef, Output, EventEmitter, OnDestroy, ViewEncapsulation } from '@angular/core';
import { from, Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { ThemeServiceHelper } from 'common/theme/service.helper';
import { EmailsService } from 'common/emails/emails.service';

@Component({
  selector: 'app-email-thread-preview',
  templateUrl: './email-thread-preview.component.html',
  styleUrls: ['./email-thread-preview.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmailThreadPreviewComponent implements OnChanges, OnDestroy {
  @Input()
  emailThreadId: string;

  @Output()
  closeAction: EventEmitter<void> = new EventEmitter();

  public emailThread;
  public lastEmail;
  public emailThreadThemeClass: string;
  private _destroyed$ = new Subject<void>();

  constructor(private _xlcEmails: EmailsService, private _changeDetector: ChangeDetectorRef) {
  }

  ngOnChanges() {
    if (this.emailThreadId) {
      this._destroyed$.next();
      this._loadThreadInfo(this.emailThreadId);
      this._loadLastEmailFromThread(this.emailThreadId);
      this._getEmailThreadClass();
    }
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  closeButtonClicked(): void {
    this.closeAction.emit();
  }

  private _loadThreadInfo(emailThreadId): void {
    this.emailThread = null;
    from(this._xlcEmails.getEmailThread(emailThreadId))
      .pipe(first(), takeUntil(this._destroyed$))
      .subscribe(response => this.emailThread = response);
  }

  private _loadLastEmailFromThread(emailThreadId: string): void {
    this.lastEmail = null;
    from(this._xlcEmails.getLastEmailFromThreadWithAttachments(emailThreadId))
      .pipe(first(), takeUntil(this._destroyed$))
      .subscribe(email => {
        this.lastEmail = email;
        this._changeDetector.detectChanges();
      });
  }

  private _getEmailThreadClass(): void {
    this.emailThreadThemeClass = ThemeServiceHelper.getCssClass(this.emailThreadId);
  }
}
